import React from "react";

const DateTimeDisplay = ({ value, type, isDanger }) => {
  return (
    <div
      className={isDanger ? "countdown danger" : "countdown"}
      style={{
        // background: "lightgrey",
        paddingTop: "10px",
        paddingBottom: "3px",
        border: "2px solid lightgrey",
        margin: "5px",
      }}
    >
      <p style={{ fontSize: "40px", color: "white" }}>{value}</p>
      <span style={{ paddingTop: "10px", color: "white" }}>{type}</span>
    </div>
  );
};

export default DateTimeDisplay;
